export const validatePagesInput = (input: string): boolean => {
  /** Allow empty input */
  if (!input) return true;

  /**
   * Regular expression to validate:
   *  - Single number: "10"
   *  - Comma-separated numbers: "10,11,12"
   *  - Range: "10-20"
   *  - Mixed: "10,11,12,20-30"
   */
  const regex =
    /^(\d+)(,\s*\d+)*|(\d+\s*-\s*\d+)(,\s*\d+\s*-\s*\d+)*|(\d+)(,\s*\d+)*\s*,\s*(\d+\s*-\s*\d+)(,\s*\d+\s*-\s*\d+)*$/;

  /** Split input to check individual parts */
  const parts = input.split(',').map((part) => part.trim());

  for (const part of parts) {
    /** Check if part is a range */
    if (part.includes('-')) {
      const [start, end] = part.split('-').map((num) => num.trim());
      if (!start || !end || isNaN(Number(start)) || isNaN(Number(end))) {
        return false;
      }
      const startNum = parseInt(start);
      const endNum = parseInt(end);
      if (startNum >= endNum) {
        return false; /** Start should be less than end */
      }
    } else {
      /** Check if part is a single number */
      if (!/^\d+$/.test(part) || isNaN(Number(part))) {
        return false;
      }
    }
  }

  /** Remove spaces for final regex check */
  return regex.test(input.replace(/\s/g, ''));
};
